<template>
  <div class='pros-spinner-component'></div>
</template>

<script>
  import {
    Spinner,
  } from '@printos/agnostic-spinner';

  export default {
    props: {
      diameter: {
      },
      id: {
        type: String,
      },
      color: {
        type: String,
      },
      printos: {
        type: Boolean,
      },
    },
    watch: {
      printos(newVal) {
        this._printos.spinner.$set({ mode: newVal ? 'printos' : 'circle' });
      },
      diameter: function(newVal) {
        this._printos.spinner.$set({diameter: newVal});
      },
      id: function(newVal) {
        this._printos.spinner.$set({id: newVal});
      },
      color: function(newVal) {
        this._printos.spinner.$set({color: newVal});
      }
    },
    mounted() {
      this._printos = {};

      this._printos.spinner = new Spinner({
        target: this.$el,
        props: {
          id: this.id,
          diameter: this.diameter,
          color: this.color,
          mode: this.printos ? 'printos' : 'circle'
        },
      });
    },
    unmounted() {
      this._printos.spinner.$destroy();
    },
  }
</script>
